import { useQuery } from '@tanstack/react-query';
import {
  AccountDetailH2hEntity,
  LookupRecipientBankAccountDto,
  RecipientBankAccountService,
} from 'services/openapi';

import { RecipientBankAccountQueryKeys } from '../constants';

export const useRecipientBankAccountControllerLookupAccount = (
  variables: LookupRecipientBankAccountDto,
  enabled: boolean = false,
) => {
  const queryKey = [RecipientBankAccountQueryKeys.LOOKUP_ACCOUNT, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<AccountDetailH2hEntity, Error>({
    queryKey,
    queryFn: () =>
      RecipientBankAccountService.recipientBankAccountControllerLookupAccount(
        variables,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!variables.bankId && !!variables.accountNumber,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
